import { ExternalLink, Radio, Sparkles } from "lucide-react";

export function CtaPro() {
  return (
    <div className="rh-cta-grid" data-testid="cta-pro-banner">
      <a
        href="#"
        className="rh-cta rh-cta-stream"
        data-testid="cta-stream-offer"
        onClick={(e) => e.preventDefault()}
      >
        <div className="rh-cta-glow" aria-hidden="true" />
        <div className="rh-cta-inner">
          <div className="rh-cta-text">
            <span className="rh-cta-eyebrow">
              <Radio size={12} /> Votre radio sur le wall
            </span>
            <span className="rh-cta-title">
              Diffusez votre webradio sur WallTunes — sans développer de PWA.
            </span>
            <span className="rh-cta-sub">
              Envoyez-nous votre lien de stream, on s'occupe du reste : logo,
              métadonnées Now Playing et pochette d'album, intégration CarPlay /
              Android Auto.
            </span>
          </div>
          <span className="rh-cta-arrow">
            Découvrir l'offre <ExternalLink size={14} />
          </span>
        </div>
      </a>

      <a
        href="#"
        className="rh-cta rh-cta-pwa"
        data-testid="cta-pwa-offer"
        onClick={(e) => e.preventDefault()}
      >
        <div className="rh-cta-glow" aria-hidden="true" />
        <div className="rh-cta-inner">
          <div className="rh-cta-text">
            <span className="rh-cta-eyebrow">
              <Sparkles size={12} /> Édition premium
            </span>
            <span className="rh-cta-title">
              Vous souhaitez votre propre PWA radio professionnelle&nbsp;?
            </span>
            <span className="rh-cta-sub">
              Application installable, design sur-mesure, lecteur audio natif et
              métadonnées temps réel.
            </span>
          </div>
          <span className="rh-cta-arrow">
            Découvrir l'offre <ExternalLink size={14} />
          </span>
        </div>
      </a>
    </div>
  );
}

export function Footer() {
  return (
    <div className="rh-footer">
      <p>
        Powered by{" "}
        <a
          href="https://www.mediawebradio.com/"
          target="_blank"
          rel="noreferrer"
          className="rh-footer-link"
          data-testid="footer-mediawebradio-link"
        >
          MEDIAWEBRADIO.COM
        </a>
      </p>
    </div>
  );
}
